<div [formGroup]="group">
  <input
    type="number"
    inputmode="decimal"
    [id]="control.name"
    [value]="control.value ?? null"
    [name]="control.name"
    [formControlName]="control.name"
  />
</div>
